import { z, ZodSchema } from 'zod';

import { DefaultGeoConfig, GeoConfig, GeoConfigData, GeoConfigLocation } from './useGeoConfig';

export const DefaultConfigSchema: ZodSchema<DefaultGeoConfig> = z.object({
  latitude: z.number(),
  longitude: z.number(),
  radius: z.number(),
});

export const GeoConfigLocationSchema: ZodSchema<GeoConfigLocation> = z.object({
  id: z.number(),
  name: z.string(),
  latitude: z.number(),
  longitude: z.number(),
  radius: z.number(),
});

export const GeoConfigSchema: ZodSchema<GeoConfig> = z.object({
  name: z.string(),
  configId: z.number(),
  locations: z.array(GeoConfigLocationSchema),
  hasActiveCampaign: z.boolean().optional(),
});

export const GeoConfigDataSchema: ZodSchema<GeoConfigData> = z.object({
  defaults: DefaultConfigSchema,
  geoConfigs: z.array(GeoConfigSchema),
});
